import { Component, Input } from '@angular/core';

/**
 * Presentational component — field error row with red circle × icon + message text.
 * Renders nothing when `message` is empty/falsy.
 *
 * Usage:
 *   <app-healthpicks-operator-field-error [message]="errorMessages.login.email" />
 */
@Component({
  selector: 'app-healthpicks-operator-field-error',
  template: `
    <div class="ho-field-error" *ngIf="message">
      <span class="ho-field-error__icon" aria-hidden="true">
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
          <circle cx="8" cy="8" r="6.4" fill="#BE4751"/>
          <path
            d="M10.18 5.02c.15-.15.39-.15.53 0 .15.15.15.39 0 .53L8.53 7.73l2.18 2.18c.15.15.15.39 0 .53-.15.15-.39.15-.53 0L8 8.26l-2.18 2.18c-.15.15-.39.15-.53 0-.15-.15-.15-.39 0-.53l2.18-2.18L5.29 5.55c-.15-.15-.15-.39 0-.53.15-.15.39-.15.53 0L8 7.2l2.18-2.18z"
            fill="white"
          />
        </svg>
      </span>
      <span class="ho-field-error__text">{{ message }}</span>
    </div>
  `,
  styles: [`
    .ho-field-error {
      display: flex;
      align-items: flex-start;
      gap: 4px;
      color: #BE4751;
      font-size: 11px;
      font-weight: 400;
      line-height: 1.5;
      letter-spacing: 0.4px;
    }

    .ho-field-error__icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      line-height: 0;
      /* vertically align icon with first line of text */
      margin-top: 1px;
    }

    .ho-field-error__text {
      flex: 1;
      min-width: 0;
    }
  `],
})
export class HealthpicksOperatorFieldErrorComponent {
  /** Error message to display. Component is hidden when falsy. */
  @Input() message = '';
}
